// Scroll configuration constants for setup demo animation
// Eliminates magic numbers and provides clear, maintainable breakpoints

export const SCROLL_CONFIG = {
  DESKTOP: {
    // Total scroll height - extended for longer pause/hold periods
    TOTAL_HEIGHT_VH: 600,

    // Step 1: Google Maps (visible 0-30%, fades out 30-35%)
    // PAUSE from 0 to 0.10, then animations 0.10-0.25, then PAUSE until 30%
    STEP_1_CONTENT_START: 0.10, // Animations start after scrolling into sticky viewport
    STEP_1_CONTENT_COMPLETE: 0.25,
    STEP_1_FADE_OUT_START: 0.30,
    STEP_1_FADE_OUT_END: 0.35,

    // Step 2: Dotypos (fades in 33-38%, visible 38-60%, fades out 60-65%)
    STEP_2_FADE_IN_START: 0.33,
    STEP_2_FADE_IN_END: 0.38,
    STEP_2_CONTENT_COMPLETE: 0.52,
    STEP_2_FADE_OUT_START: 0.60,
    STEP_2_FADE_OUT_END: 0.65,

    // Step 3: Dashboard (fades in 63-68%, visible 68-100%)
    STEP_3_FADE_IN_START: 0.63,
    STEP_3_FADE_IN_END: 0.68,
    STEP_3_CONTENT_COMPLETE: 0.88,
  },

  MOBILE: {
    // Mobile scroll height with comfortable pause periods
    TOTAL_HEIGHT_VH: 400,

    // Step 1: PAUSE 0-0.10, animations 0.10-0.25, pause until 30%, fade out 30-35%
    STEP_1_CONTENT_START: 0.10,
    STEP_1_CONTENT_COMPLETE: 0.25,
    STEP_1_FADE_OUT_START: 0.30,
    STEP_1_FADE_OUT_END: 0.35,

    // Step 2: fades in 33-38%, visible 38-60%, fades out 60-65%
    STEP_2_FADE_IN_START: 0.33,
    STEP_2_FADE_IN_END: 0.38,
    STEP_2_CONTENT_COMPLETE: 0.52,
    STEP_2_FADE_OUT_START: 0.60,
    STEP_2_FADE_OUT_END: 0.65,

    // Step 3: fades in 63-68%, visible 68-100%
    STEP_3_FADE_IN_START: 0.63,
    STEP_3_FADE_IN_END: 0.68,
    STEP_3_CONTENT_COMPLETE: 0.88,
  }
} as const;

// Mobile breakpoint matching existing use-mobile.tsx pattern
export const MOBILE_BREAKPOINT = 768;

// Visibility buffer for conditional rendering (prevents flicker)
export const VISIBILITY_BUFFER = 0.05; // 5% buffer before/after step visibility
